<script>
import Layout from "../../layouts/auth";
import {
  authMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required, email, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import router from '../../index';

const DEFAULT_PRODUCT_NAME="Recepcionador para Proveedores";
const P724_RFC="CRA0404041I0";
const P724_PRODUCT_NAME="Recepcionador Proveedores 7/24";

const DEFAULT_TENANT = process.env.VUE_APP_DEFAULT_TENANT

if(!DEFAULT_TENANT){
  console.error("DEFAULT_TENANT:", DEFAULT_TENANT)
}else{
  console.log("DEFAULT_TENANT:", DEFAULT_TENANT)
}
/**
 * Login component
 */
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      rfc: DEFAULT_TENANT,
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      loading: false,
    };
  },
  validations: {
    email: {
      required: helpers.withMessage("El correo electrónico es requerido", required),
      email: helpers.withMessage("Formato de correo electrónico inválido", email),
    },
    password: {
      required: helpers.withMessage("La contraseña es requerida", required),
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    applicationName() {
      switch (this.rfc) {
        case P724_RFC:
            return P724_PRODUCT_NAME
      
        default:
          return DEFAULT_PRODUCT_NAME
      }
    },
    isKnownTenant() {
      return [P724_RFC].includes(this.rfc)
    }
  },
  methods: {
    ...authMethods,
    ...notificationMethods,
    clearNotification() {
      this.$store.dispatch('notification/clear');
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword; // Alterna entre mostrar y ocultar la contraseña
    },
    // Try to log the user in with the username
    // and password they provided.
    async tryToLogIn() {
      this.submitted = true;
      this.loading = true;
      this.clearNotification();

      this.v$.$touch();
      if (this.v$.$invalid) {
        this.loading = false;
        return;
      } else {
        const body = {
          email: this.email,
          password: this.password,
          rfc: this.rfc
        }
        const resp = await this.loginAction(body)
        if (resp === "success") {
          this.loading = false;
          router.push("/")
        } else {
          this.loading = false;
        }
      }
    },
  },
  mounted() {
    let urlParams = new URLSearchParams(window.location.search);

    urlParams.forEach((value, key) => {
      if(key == 'tenant' &&  value == P724_RFC){
        this.rfc =P724_RFC;
      }
    });
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Bienvenido a {{applicationName}}!</h5>
                  <p>Autenticate para continuar a {{applicationName}}.</p>
                </div>
              </div>
              <div class="col-5 align-self-center">
                <!--TODO: retrieve from API-->
                <img v-if="isKnownTenant"
                  src="@/assets/images/logo724.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <!-- <router-link to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="34" />
                  </span>
                </div>
              </router-link> -->
            </div>
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
              >{{ authError }}</b-alert
            >
            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
              class="mt-3"
            >
              {{ notification.message }}
            </div>

            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group
                class="mb-3"
                id="input-group-1"
                label="Correo Electrónico"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  placeholder="Ingresa tu correo"
                  :class="{
                    'is-invalid': submitted && v$.email.$error,
                  }"
                ></b-form-input>
                <div
                  v-for="(item, index) in v$.email.$errors"
                  :key="index"
                  class="invalid-feedback"
                >
                  <span v-if="item.$message">{{ item.$message }}</span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="input-group-2"
                label="Contraseña"
                label-for="input-2"
              >
                <div class="input-group">
                  <!-- Campo de contraseña -->
                  <b-form-input
                    id="input-2"
                    v-model="password"
                    :type="showPassword ? 'text' : 'password'"
                    placeholder="Ingresa tu contraseña"
                    :class="{
                      'is-invalid': submitted && v$.password.$error,
                    }">
                  </b-form-input>
                  <!-- Mostrar/Ocultar ícono -->
                  <span v-if="password.length > 0" class="input-group-text" @click="togglePasswordVisibility"
                    style="cursor: pointer">
                    <i :class="showPassword ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"></i>
                  </span>
                </div>
                <!-- Mensajes de error, si los hay -->
                <div
                  v-if="submitted && v$.password.$error"
                  class="invalid-feedback d-block"
                >
                  <span v-for="(item, index) in v$.password.$errors" :key="index">
                    {{ item.$message }}
                  </span>
                </div>
              </b-form-group>
              <!-- <b-form-checkbox
                class="form-check me-2 mt-0"
                id="customControlInline"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
              >Remember me
              </b-form-checkbox> -->
              <div class="mt-3 d-grid">
                <b-button type="submit" variant="primary" class="btn-block" :disabled="loading">
                  <b-spinner small v-if="loading" class="mr-2" label="Loading..."></b-spinner>
                  <span v-if="!loading">Iniciar sesión</span>
                  <span v-else>Cargando...</span>
                </b-button
                >
              </div>
              <!-- <div class="mt-4 text-center">
                <ul class="list-group list-group-horizontal">
                  <li class="list-group-item"><a href="https://www.sifei.com.mx" title="SIFEI México">
                      <i class="mdi mdi-web"></i></a></li>
                  <li class="list-group-item"><a href="https://www.linkedin.com/company/sifeimexico" title="LinkedIn">
                      <i class="mdi mdi-linkedin"></i></a></li>
                  <li class="list-group-item"><a href="https://www.facebook.com/sifeimexico" title="Facebook">
                      <i class="mdi mdi-facebook"></i></a></li>
                  <li class="list-group-item"><a href="https://twitter.com/sifeimexico" title="Twitter">
                      <i class="mdi mdi-twitter"></i></a></li>
                  <li class="list-group-item"><a href="https://www.youtube.com/SifeiMexico" title="Canal de Sifei">
                      <i class="mdi mdi-youtube"></i></a></li>
                  <li class="list-group-item"><a href="https://github.com/sifeimexico" title="Sifei para desarrolladores">
                      <i class="mdi mdi-github"></i></a>
                  </li>
                </ul>
              </div> -->
              <!-- <div class="mt-4 text-center">
                <h5 class="font-size-14 mb-3">Sign in with</h5>

                <ul class="list-inline">
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="
                        social-list-item
                        bg-primary
                        text-white
                        border-primary
                      "
                    >
                      <i class="mdi mdi-facebook"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-info text-white border-info"
                    >
                      <i class="mdi mdi-twitter"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="
                        social-list-item
                        bg-danger
                        text-white
                        border-danger
                      "
                    >
                      <i class="mdi mdi-google"></i>
                    </a>
                  </li>
                </ul>
              </div> -->
              <div class="mt-4 text-center">
                <!-- <router-link to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock me-1"></i> ¿Olvidaste tu contraseña?
                </router-link> -->
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <!-- <p>
            ¿No tienes cuenta?
            <router-link to="/register" class="fw-medium text-primary"
              >Registrarse ahora</router-link
            >
          </p> -->
          <p>
            © 2024 Recepcionador Proveedores. Hecho con
            <i class="mdi mdi-heart text-danger"></i> por <a href="https://www.sifei.com.mx/">Sifei</a>
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>